import type { OurContext } from '../context';
import { buildStandardHeaders, request } from '../util/network';

export interface SubmitResponse {
  phoneNumber?: string;
}

export async function submitPhoneNumber(
  context: OurContext,
  phoneNumber: string
): Promise<SubmitResponse> {
  if (!context.claims) {
    throw new Error('No claims');
  }
  const body = { phoneNumber };
  const res = await request(
    context.claims.url,
    'POST',
    buildStandardHeaders(context.apiSubscriptionId, context.apiAuth),
    body,
    3
  );
  if (!(res?.ok && res.status >= 200 && res.status < 300)) {
    throw res;
  }
  if (res.headers.get('Content-Type')?.indexOf('application/json') !== -1) {
    return res.json();
  }
  throw res.text();
}
